import React from 'react'
import * as PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { Dropdown, Navbar } from '@headtrip/components-react'
import AppSwitcher from '../AppSwitcher/AppSwitcher'

import logo from '../../../images/hetzner-logo.svg'

class NavBar extends React.Component {
  constructor (props) {
    super(props)
    this.renderNavItems = this.renderNavItems.bind(this)
    this.renderToggleButton = this.renderToggleButton.bind(this)
  }

  // Render Nav Entries in dropdown-menu
  renderNavItems () {
    return this.props.navItems.map((entry, index) => {
      if (!entry.visible) return
      let url = entry.to
      let comingSoonTag = null
      // change style and add tag for coming soon entries
      if (entry.to === null) {
        comingSoonTag = <span className='nav-coming-soon-tag d-block text-center'>Coming soon!</span>
        url = '#'
      }
      return entry.visible && (
        <Dropdown.Item
          key={'nav-link' + index}
          as='li'
          className='p-0'
        >
          <Link to={url} className='link-unstyled'>
            <div className='d-flex align-items-center px-3 py-2 border-bottom'>
              {NavBar.getIcon(entry.icon)}
              <div>
                <strong>{entry.text}</strong>
                {comingSoonTag}
              </div>
            </div>
          </Link>
        </Dropdown.Item>
      )
    })
  }

  // Render Nav Entry showing the current active plattform based on the current url
  renderToggleButton () {
    return (
      this.props.navItems
        .filter(entry => entry.to === this.props.basePath)
        .map((entry, index) => {
          let navItemText = entry.to === '/' ? 'Choose Platform' : entry.text
          return (
            <Dropdown.Toggle
              key={'nav-toggle-' + index}
              id='dropdown-apps'
              variant={'white'}
              className='btn-sm d-flex align-items-center'
            >
              {NavBar.getIcon(entry.icon)}
              {navItemText}
            </Dropdown.Toggle>
          )
        })
    )
  }

  // Set icon for currently active plattform
  static getIcon (icon) {
    return icon && <img src={icon} alt=''
      className='mr-2'
      width={21}
      height={21} />
  }

  render () {
    return (
      <header>
        <Navbar bg={'white'} className='py-0 shadow-sm' style={{height: '64px', padding: '25px'}}>
          <Navbar.Brand
            as={() => {
              return <Link to={'/'}
                className={'d-flex align-items-center mr-0 py-0 mr-4 border-right-1 link-unstyled shadow-none'}>
                <img className='logo-top-bar'
                  height={21}
                  src={logo}
                  alt='Logo Hetzner Online GmbH' />
                <span className='d-none d-sm-block ml-2 h5 mb-0'>Community</span>
              </Link>
            }}>
          </Navbar.Brand>
          <Navbar.Collapse id='main-navbar'>
            {/*    <Nav className='border-left pl-4 mr-auto'>
              {
                this.showNavDropdown && this.renderNavDropdown()
              }
            </Nav> */}
            <AppSwitcher />
          </Navbar.Collapse>

        </Navbar>
      </header>
    )
  }
}

export default NavBar

Navbar.propTypes = {
  siteTitle: PropTypes.string,
  basePath: PropTypes.string,
  navItems: PropTypes.shape({
    visible: PropTypes.bool,
    to: PropTypes.string,
    text: PropTypes.string,
    icon: PropTypes.object,
    showNavDropdown: PropTypes.bool.isRequired
  })
}
